import { Map } from "immutable";
import * as UzdtActions from "../../actions/recharge/usdt";
var initialState = Map({
    fetching: null,
    usdtError: null,
    infoWallet: null,
    state: null,
    stateUsdtError: null,
    amount: null,
});
export default (function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case UzdtActions.CREATE_WALLET_USDT:
            state = state.update("state", function () { return null; });
            return state.update("fetching", function () { return true; });
        case UzdtActions.SUCCESS_CREATE_WALLET_USDT:
            state = state.update("fetching", function () { return false; });
            if (action.data.error) {
                state = state.update("usdtError", function () { return action.data.error; });
                return state;
            }
            state = state.update("infoWallet", function () { return action.data; });
            state = state.update("usdtError", function () { return null; });
            return state;
        case UzdtActions.FAILURE_CREATE_WALLET_USDT:
            state = state.update("fetching", function () { return false; });
            return state;
        case UzdtActions.FETCH_STATUS_CREATED_USDT:
            return state.update("fetching", function () { return true; });
        case UzdtActions.SUCCESS_FETCH_STATUS_CREATED_USDT:
            state = state.update("fetching", function () { return false; });
            if (action.data.error) {
                return state.update("stateUsdtError", function () { return action.data.error; });
            }
            state = state.update("state", function () { return action.data.state; });
            state = state.update("amount", function () { return action.data.amount; });
            return state;
        case UzdtActions.FAILURE_FETCH_STATUS_CREATED_USDT: {
            state = state.update("fetching", function () { return false; });
            return state;
        }
        case UzdtActions.CLEAR_USDT_STATE:
            state = state.update("state", function () { return null; });
            state = state.update("stateUsdtError", function () { return null; });
            state = state.update("amount", function () { return null; });
            return state;
        default:
            return state;
    }
});



// WEBPACK FOOTER //
// ./src/reducers/recharge/usdtRechargeReducer.js